export default {
  title: 'Kurzbefehle',
  links: {
    reservations: 'Reservierungen',
    orders_portal: 'Terminal-Login',
    closed: 'Geschlossen?',
    menu: 'Menü ändern',
    payouts: 'Auszahlungsberichte',
    opening_hours: 'Öffnungszeiten',
  },
};
